import React from 'react';
import { FormattedMessage } from 'react-intl';
import P from '../../../../../components/P';
import A from '../../../../../components/A';
import messages from '../../messages';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';
export default function DuesProtectPrivacyStatements() {
  return (
    <div>
      <Section>
        <ControlContainer>
          <P style={{ fontWeight: 'bold' }}>
          PRIVACY STATEMENTS
          </P>
          <P>
            <A style={{ fontWeight: 'bold' }}>SureGo Administrators Privacy Statement</A><br></br>
          Our privacy statement explains how we collect, use, share, and protect your personal information. We respect your right to privacy and promise to treat your personal information responsibly.
          </P>
          <P>
            <A style={{ fontWeight: 'bold' }}>Confidentiality and security </A>
            We follow all data security laws. We protect your information by using physical, technical, and procedural safeguards. We limit access to your information to those who need it to do their jobs. Our business partners are legally bound to use your information for permissible purposes.
          </P>
          <P>
            <A style={{ fontWeight: 'bold' }}>State or Country Standards </A>
            We follow the standards set forth for evaluating and processing wavier(s) for hardship requests.
          </P>
          <P>
            <A style={{ fontWeight: 'bold' }}>Collecting and using your personal information </A>
            We collect personal information about you when you seek services from u on products purchased and/or processed via Trawick International and/or its client distributor(s).  The information comes from your application, business transactions with us, consumer reports, medical providers, and publicly available sources. Please know that we only use that information to service or market products to you.
          </P>
          <P>
            We typically collect and use the following types of information:
          </P>
          <ul>
            <li>
            Name, address, and Social Security number
            </li>
            <li>
            Assets and income and/or employer
            </li>
            <li>
            Information to support a Hardship Request
            </li>
            <li>
            Information related to your account to support a hardship request and/or service your account
            </li>
            <li>
            Credit reports and other consumer report information
            </li>
            <li>
            Family member and/or beneficiary information
            </li>
            <li>
            Public information
            </li>
          </ul>
          <P>
            <A style={{ fontWeight: 'bold' }}>Sharing your information for business purposes </A>
            We share your information with other SureGo companies and business partners. When you buy a product, we share your personal information for everyday purposes, such as mailing your statements or posting or processing transactions that you request. You cannot opt out of these. We also share your information where federal and state law requires.
          </P>
          <P>
            <A style={{ fontWeight: 'bold' }}>Sharing your information for marketing purposes </A>
            We don’t sell your information for marketing purposes, and only share your personal information with those we deem helpful to service your product, so you have no logical reason opt out. If we change our policy, we’ll tell you and give you the opportunity to opt out before we send your information.
            Using your medical, employment, and other information We sometimes collect medical and/or employer information. We may use this information to evaluate a hardship request, and/or to provide a service. We may share this information for these business purposes if required or permitted by law.   We will not use it for marketing purposes unless you give us permission.
          </P>
          <P>
            <A style={{ fontWeight: 'bold' }}>Accessing your information </A>
            You can ask us for a copy of your personal information. Please send a letter to the address below with a notarized signature on the request, so we may prove your identity. We don’t charge a fee for giving you a copy of your information now, but we may charge a small fee in the future. We can’t update information that other companies, like credit agencies and third parties, provide to us, so will only provide you our information.   With your notarized signature, please include your name, full address, country, plan number, and whom you purchased your wavier from.
          </P>
          <P>
          SureGo Administrators<br></br>
          Attn: Privacy Officer<br></br>
          P.O. Box 2069<br></br>
          Fairhope, AL  36533
          </P>
        </ControlContainer>
      </Section>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/DuesProtectPrivacyStatements/index.js